import map from "./map";

export default {
  map
};


// WEBPACK FOOTER //
// ./src/utils/map/index.js